(function () {
  const APPS_SCRIPT_URL = "https://script.google.com/macros/s/AKfycbwffcUgvStT4ulE86Fjg1FOYayAwYLPznTX2zsb5_Yvzm0_Sf8NQ4_MWwTvwO3BIJht3A/exec";
  const HOME_LAT = -21.26414914238359;
  const HOME_LNG = 55.507601665977;

  function mount(root){
    root.innerHTML = `
      <div class="mmR-wrap">
        <div class="mmR-head">
          <input id="mmRQ" class="mmR-input" type="search" placeholder="Recherche: #1422, Saint-André, Sabrina…" style="flex:1;min-width:240px">
          <button id="mmRReload" class="mmR-btn" type="button">Reload</button>
          <button id="mmRCalc" class="mmR-btn" type="button">Optimiser l’itinéraire</button>
          <div id="mmRInfo" class="mmR-meta"></div>
        </div>

        <div class="mmR-grid">
          <div class="mmR-card">
            <div class="mmR-meta" style="margin-bottom:8px;">
              Départ : <span class="mmR-strong">Maison</span> (aller simple)
            </div>
            <div class="mmR-list" id="mmRList"></div>
          </div>

          <div class="mmR-card">
            <div id="mmRMap"></div>
            <div class="mmR-stops" id="mmRStops"></div>
          </div>
        </div>
      </div>
    `;

    const qEl = root.querySelector("#mmRQ");
    const listEl = root.querySelector("#mmRList");
    const infoEl = root.querySelector("#mmRInfo");
    const stopsEl = root.querySelector("#mmRStops");
    const btnReload = root.querySelector("#mmRReload");
    const btnCalc = root.querySelector("#mmRCalc");

    let orders = [];
    let map, routeLayer;
    const markers = [];

    function norm(s){ return (s||"").toLowerCase().trim(); }

    function escapeHtml(str){
      return String(str||"").replace(/[&<>"']/g, m => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m]));
    }

    function renderList(){
      const q = norm(qEl.value);
      const filtered = orders.filter(o => {
        const hay = norm(`#${o.orderNumber} ${o.shippingName} ${o.city} ${o.zip} ${o.address1}`);
        return !q || hay.includes(q);
      });

      infoEl.textContent = `${filtered.length} commandes (coords: ${orders.filter(o=>o.lat&&o.lng).length}/${orders.length})`;

      listEl.innerHTML = filtered.map(o => `
        <label class="mmR-row">
          <input type="checkbox" class="mmRChk" data-id="${o.orderNumber}">
          <div>
            <div class="mmR-strong">#${o.orderNumber} — ${escapeHtml(o.shippingName || "")}</div>
            <div class="mmR-meta">${escapeHtml(o.address1 || "")}, ${escapeHtml(o.zip || "")} ${escapeHtml(o.city || "")}</div>
            ${o.address2 ? `<div class="mmR-meta">🧾 ${escapeHtml(o.address2)}</div>` : ``}
            ${o.phone ? `<div class="mmR-meta">📞 ${escapeHtml(o.phone)}</div>` : ``}
          </div>
        </label>
      `).join("");
    }

    async function loadOrders(){
      infoEl.textContent = "Chargement orders…";
      const r = await fetch(APPS_SCRIPT_URL + "?action=orders", { cache: "no-store" });
      const j = await r.json();
      if (!j.ok) throw new Error(j.error || "orders not ok");
      orders = j.orders || [];
      infoEl.textContent = `OK — ${j.count} commandes (geocodées: +${j.geocodedThisCall})`;
      renderList();
    }

    function selectedIds(){
      return Array.from(root.querySelectorAll(".mmRChk:checked"))
        .map(cb => parseInt(cb.dataset.id, 10))
        .filter(Number.isFinite);
    }

    async function computeRoute(){
  const ids = selectedIds();
  if (!ids.length) return alert("Sélectionne au moins 1 commande.");

  btnCalc.disabled = true;
  btnCalc.textContent = "Calcul…";

  const qs = new URLSearchParams({
    action: "route",
    startLat: String(HOME_LAT),
    startLng: String(HOME_LNG),
    selected: ids.join(",")
  });

  const r = await fetch(APPS_SCRIPT_URL + "?" + qs.toString(), { cache: "no-store" });
  const j = await r.json();

  if (!j.ok) {
  console.error("Route error payload:", j);
  throw new Error(`${j.error || "route not ok"} (HTTP ${j.http_code || "?"})`);
}


  if (!j.ok) throw new Error(j.error || "route not ok");
  drawRoute(j);

  btnCalc.textContent = "Optimiser l’itinéraire";
  btnCalc.disabled = false;
}


    function initMap(){
      map = L.map("mmRMap", { zoomControl: true }).setView([HOME_LAT, HOME_LNG], 11);
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        maxZoom: 19,
        attribution: '&copy; OpenStreetMap'
      }).addTo(map);

      const homeIcon = L.divIcon({ className:"", html:`<div style="background:#0f0f11;border:1px solid rgba(255,255,255,.25);padding:6px 10px;border-radius:999px;color:#fff;font-weight:900">🏠 Départ</div>` });
      L.marker([HOME_LAT, HOME_LNG], { icon: homeIcon }).addTo(map);
    }

    function clearMap(){
      markers.forEach(m => map.removeLayer(m));
      markers.length = 0;
      if (routeLayer) { map.removeLayer(routeLayer); routeLayer = null; }
    }

    function drawRoute(res){
      clearMap();

      routeLayer = L.geoJSON(res.geojson, {
        style: () => ({ weight: 5, opacity: 0.9 })
      }).addTo(map);

      stopsEl.innerHTML = "";

      const bounds = [];
      res.orderedStops.forEach(s => {
        bounds.push([s.lat, s.lng]);

        const icon = L.divIcon({
          className: "",
          html: `<div style="width:30px;height:30px;border-radius:999px;background:#0f0f11;border:1px solid rgba(255,255,255,.4);color:#fff;display:flex;align-items:center;justify-content:center;font-weight:900">${s.seq}</div>`
        });

        const m = L.marker([s.lat, s.lng], { icon }).addTo(map);
        m.bindPopup(`<b>#${s.orderNumber}</b><br>${escapeHtml(s.address1 || "")}<br>${escapeHtml(s.zip || "")} ${escapeHtml(s.city || "")}`);
        markers.push(m);

        stopsEl.insertAdjacentHTML("beforeend", `
          <div class="mmR-stop">
            <span class="mmR-badge">Stop ${s.seq}</span>
            <span class="mmR-strong">#${s.orderNumber}</span> — ${escapeHtml(s.shippingName || "")}<br>
            <span class="mmR-meta">${escapeHtml(s.address1 || "")}, ${escapeHtml(s.zip || "")} ${escapeHtml(s.city || "")}</span>
            ${s.address2 ? `<div class="mmR-meta">🧾 ${escapeHtml(s.address2)}</div>` : ``}
            ${s.phone ? `<div class="mmR-meta">📞 ${escapeHtml(s.phone)}</div>` : ``}
          </div>
        `);
      });

      if (bounds.length) map.fitBounds(bounds, { padding:[30,30] });

      if (res.summary && typeof res.summary.distance === "number") {
        const km = (res.summary.distance / 1000).toFixed(1);
        const min = Math.round(res.summary.duration / 60);
        infoEl.textContent = `Itinéraire OK — ${bounds.length} stops — ~${km} km — ~${min} min`;
      } else {
        infoEl.textContent = `Itinéraire OK — ${bounds.length} stops`;
      }

      btnCalc.textContent = "Optimiser l’itinéraire";
      btnCalc.disabled = false;
    }

    qEl.addEventListener("input", renderList);
    btnReload.addEventListener("click", loadOrders);
    btnCalc.addEventListener("click", () => computeRoute().catch(err => {
      console.error(err);
      alert("Erreur route: " + (err && err.message ? err.message : String(err)) + "\n\n(Regarde la console F12 pour plus de détails)");
      btnCalc.textContent = "Optimiser l’itinéraire";
      btnCalc.disabled = false;
    }));

    initMap();
    loadOrders().catch(err => {
      console.error(err);
      infoEl.textContent = "Erreur chargement orders (Apps Script / Sheet).";
    });
  }

  function boot(){
    document.querySelectorAll("[data-mm-route]").forEach(el => mount(el));
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
